import { FuelTypography } from '@frete.com/fuel-react';
import ContactListButton from 'components/ui/Menu/ContactListButton';
import React from 'react';
import { VerifiedBadge } from '../VerifiedBadge';
import { VipTag } from '../VipTag';
import * as Styled from './styled';

export const Name: React.FC<{
  name: string;
  isVerified: boolean;
  scrolledValue: number;
  inContactlist: boolean;
  hasContactFeature: boolean;
  showCloseButton: boolean;
  isSmallProfile: boolean;
  isVip: boolean;
  showStickyName: boolean;
}> = ({
  isVerified,
  name,
  hasContactFeature,
  inContactlist,
  isSmallProfile,
  scrolledValue,
  showCloseButton,
  isVip,
  showStickyName,
}) => (
  <Styled.ContentWrapper
    scrolledValue={scrolledValue}
    isSmallProfile={isSmallProfile}
    showCloseButton={showCloseButton}
    showStickyName={showStickyName}
    data-testid="name-wrapper"
  >
    <Styled.NameWrapper
      scrolledValue={scrolledValue}
      showContactButton={!isSmallProfile && hasContactFeature}
      isSmallProfile={isSmallProfile}
      inContactList={inContactlist}
    >
      <FuelTypography weight="bold" size="heading-sm" color="neutral-strong" data-testid="trucker-name">
        {name}
      </FuelTypography>
      {isVerified && <VerifiedBadge />}
      {isVip && <VipTag />}
    </Styled.NameWrapper>

    {!isSmallProfile && hasContactFeature && (
      <Styled.ContactListButtonWrapper scrolledValue={scrolledValue}>
        <ContactListButton />
      </Styled.ContactListButtonWrapper>
    )}
  </Styled.ContentWrapper>
);
